import React from "react";
import JSZip from 'jszip';
import {Button, Grid} from "@mui/material";

export function JsonUpload (props: any) {
    const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        if (event.target.files != null) {
            const fileReader: FileReader = new FileReader();
            fileReader.readAsText(event.target.files[0], 'UTF-8');
            fileReader.onload = (event) => {
                if (event.target != null && typeof event.target.result === "string") {
                    props.setData(JSON.parse(event.target.result));
                } else {
                    alert('data is not valid');
                }
            }
        }
    }

    return (
        <Grid item>
            <input
                type='file'
                accept='.json'
                id='upload-file'
                hidden
                onChange={(e) => handleUpload(e)}
            />
            <label htmlFor='upload-file'>
                <Button
                    variant='outlined'
                    component='span'
                    sx={{ height: '100%'}}
                >
                    JSON 업로드
                </Button>
            </label>
        </Grid>
    );
}

export function JsonDownload (props: any) {
    const handleDownload = async () => {
        const json: string = JSON.stringify(props.getData());
        const blob = new Blob([json], {type: 'application/json'});
        const href = await URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = props.name + '.json';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Grid item>
            <Button
                variant='outlined'
                onClick={handleDownload}
                sx={{ ml: 1, height: '100%'}}
            >
                JSON 다운로드
            </Button>
        </Grid>
    );
}

export function ZipJsonDownload (props: any) {
    const handleDownload = async () => {
        const files = await props.getFiles();

        if(files.length === 0){
            alert('다운로드할 데이터가 없습니다.');
            return;
        }

        const zip = new JSZip();

        files.forEach((file: { fileName: string, data: any }) => {
            zip.file(file.fileName, JSON.stringify(file.data));
        });

        const blob = await zip.generateAsync({type: 'blob'});
        const href = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = href;
        link.download = props.name + '.zip';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    };

    return (
        <Grid item>
            <Button
                variant='outlined'
                onClick={handleDownload}
                sx={{ ml: 1, height: '100%', whiteSpace: 'nowrap'}}
            >
                {props.text || 'JSON 다운로드'}
            </Button>
        </Grid>
    );
}
